export abstract class UserUtils {
  static async checkIfUserExists(email: string) {
    const url = `/api/user-by-email/${email}`;
    const response = await fetch(url, {
      method: 'HEAD',
      headers: {
        'Content-Type': 'application/json'
      },
      cache: 'no-cache'
    });
    return response.status === 204;
  }
}
